// WinAndLoseUI.js
var WinAndLoseUi = pc.createScript('winAndLoseUi');

WinAndLoseUi.attributes.add('GameEnt', {type: 'entity'});
WinAndLoseUi.attributes.add('PanelBackground', {type: 'entity'});
WinAndLoseUi.attributes.add('PanelPosition', {type: 'entity'});
WinAndLoseUi.attributes.add('ExtraScorePanelPosition', {type: 'entity'});
WinAndLoseUi.attributes.add('winPanelTemplate', {type: 'asset', assetType: 'template'});
WinAndLoseUi.attributes.add('offerPanelTemplate', {type: 'asset', assetType: 'template'});
WinAndLoseUi.attributes.add('losePanelTemplate', {type: 'asset', assetType: 'template'});
WinAndLoseUi.attributes.add('perfectScorePanelTemplate', {type: 'asset', assetType: 'template'});

var checkOffer = true;
var winLoseSelf;
var winScore = 0;

WinAndLoseUi.prototype.initialize = function() {

    WinAndLoseUi.instance = this;
    winLoseSelf = this;
    this.app.on('gameManager:updatestatus',this.Status,this);
    this.entity.on("destroy", this.OnDestroy,this);
};

WinAndLoseUi.prototype.showTopBar = function() {
    this.GameEnt.enabled = true;
};

WinAndLoseUi.prototype.showPanelBackground = function(status) {
    this.PanelBackground.enabled = status;
};

WinAndLoseUi.prototype.Status = function (stat) {

    if (stat === gamestatus.Win) {
        this.showPanelBackground(true);
        Touch.instance.Pause();
        checkOffer = true;
        this.showPanel = this.winPanelTemplate.resource.instantiate();

        setTimeout(() => {
            if (completeMatchStatus == true) {
                if (levelUpStatus == true) {
                    WinAndLoseUi.instance.showPerfectScoreBanner(false,this.showPanel.children[3],this.showPanel.children[7],true,true);
                }
                else {
                    WinAndLoseUi.instance.showPerfectScoreBanner(false,this.showPanel.children[3],this.showPanel.children[7],true,false);
                }   
            }
            WinAndLoseUi.instance.PanelPosition.addChild(this.showPanel);

        }, 1250, this);

    }
    else if (stat === gamestatus.Lose) {
        this.showPanelBackground(true);
        Touch.instance.Pause();

        if ((checkOffer == true)) {
            if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
                gdsdk
                    .preloadAd('rewarded')
                    .then(response => {
                        this.showPanel = this.offerPanelTemplate.resource.instantiate();
                        WinAndLoseUi.instance.PanelPosition.addChild(this.showPanel);

                    })
                    .catch(error => {
                        this.showPanel = this.losePanelTemplate.resource.instantiate();
                        WinAndLoseUi.instance.PanelPosition.addChild(this.showPanel);
                    });
            }
            //this.showPanel = this.offerPanelTemplate.resource.instantiate();
        }
        else {
            this.showPanel = this.losePanelTemplate.resource.instantiate();
            checkOffer = true;
            WinAndLoseUi.instance.PanelPosition.addChild(this.showPanel);
        }
        
    }
};

WinAndLoseUi.prototype.showPerfectScoreBanner = function (isLost,winScoreLabel,starPosition,startAnimation,unlockNewPlaces) {

    WinAndLoseUi.instance.perfectBanner = this.perfectScorePanelTemplate.resource.instantiate();
    WinAndLoseUi.instance.perfectBanner.script.perfectScoreBanner.isLostStatus(isLost);
    WinAndLoseUi.instance.perfectBanner.script.perfectScoreBanner.winScore = winScoreLabel;
    WinAndLoseUi.instance.perfectBanner.children[0].script.extraScoreStarAnimation.pointB = starPosition;
    WinAndLoseUi.instance.perfectBanner.children[3].element.text = earnExtraPointsScore;
    WinAndLoseUi.instance.perfectBanner.children[2].element.text = "Extra " + earnExtraPointsScore + " stars!";
     WinAndLoseUi.instance.ExtraScorePanelPosition.addChild(WinAndLoseUi.instance.perfectBanner);
     
    if (unlockNewPlaces == false) {
        WinAndLoseUi.instance.ExtraScorePanelPosition.children[0].setLocalPosition(new pc.Vec3(0, 667.87, 0));
    }
    else {
        WinAndLoseUi.instance.ExtraScorePanelPosition.children[0].setLocalPosition(new pc.Vec3(0, 558.668, 0));
    }

    if (startAnimation) {PerfectScoreBanner.instance.extraPointStartAnimation();}
    
};

WinAndLoseUi.prototype.OnDestroy = function(){
    ConfettiEffect.instance.DisableConfetti();
    this.app.off('gameManager:updatestatus',this.Status,this);
    this.entity.off("destroy", this.OnDestroy,this);
};



